import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';

export const FETCH_USERINFO_LOADING = 'FETCH_USERINFO_LOADING';
export const FETCH_USERINFO_SUCCESS = 'FETCH_USERINFO_SUCCESS';
export const FETCH_USERINFO_FAILED = 'FETCH_USERINFO_FAILED';
export const FETCH_USERLOGINLIST_LOADING = 'FETCH_USERLOGINLIST_LOADING';
export const FETCH_USERLOGINLIST_SUCCESS = 'FETCH_USERLOGINLIST_SUCCESS';
export const FETCH_USERLOGINLIST_FAILED = 'FETCH_USERLOGINLIST_FAILED';
export const FETCH_DEVICELIST_LOADING = 'FETCH_DEVICELIST_LOADING';
export const FETCH_DEVICELIST_SUCCESS = 'FETCH_DEVICELIST_SUCCESS';
export const FETCH_DEVICELIST_FAILED = 'FETCH_DEVICELIST_FAILED';

export const FETCH_WRITEOFFf_LOADING = 'FETCH_WRITEOFFf_LOADING';
export const FETCH_WRITEOFFf_SUCCESS = 'FETCH_WRITEOFFf_SUCCESS';
export const FETCH_FAMILYLIST_SUCCESS = 'FETCH_FAMILYLIST_SUCCESS';

/**
 * 设置用户信息
 * @param {*} param
 */
export function resetData(data, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_USERINFO_SUCCESS,
      userInfo: data,
    });
    dispatch({
      type: FETCH_USERLOGINLIST_SUCCESS,
      loginList: [],
      loginPageTotal: 0,
    });
    dispatch({
      type: FETCH_DEVICELIST_SUCCESS,
      deviceList: [],
      devicePageTotal: 0,
    });

  };
}
/**
 * 获取用户信息
 * @param {*} param
 */
export function fetchUserinfo(param, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      account: ''
    }
    const req = Object.assign({}, defaultParam, param);
    const { account = '' } = req;
    if (account == '') {
      dispatch({
        type: FETCH_USERINFO_SUCCESS,
        userInfo: {},
      });
      return;
    }
    dispatch({
      type: FETCH_USERINFO_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/info`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_USERINFO_SUCCESS,
          userInfo: res.data || {},
        });
        callback && callback();
      } else {
        // 未找到用户信息
        message.warn(res.msg);
        dispatch({
          type: FETCH_USERINFO_SUCCESS,
          userInfo: {},
        });
        dispatch({
          type: FETCH_USERLOGINLIST_SUCCESS,
          loginList: [],
          loginPageTotal: 0,
        });
        dispatch({
          type: FETCH_DEVICELIST_SUCCESS,
          deviceList: [],
          devicePageTotal: 0,
        });
        dispatch({
          type: FETCH_FAMILYLIST_SUCCESS,
          familyList: [],
          familyPageTotal: 0,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_USERINFO_FAILED,
      });
    })
  };
}
/**
 * 获取用户登陆信息
 * @param {object} param 
 * @returns 
 */
export function fetchUserLoginList(param) {
  return (dispatch, getState) => {
    const { userId } = getState().queryUser.userInfo;
    if (!!userId) {
      const defaultParam = {
        userId,
        useType: 0,
      }
      const req = Object.assign({}, defaultParam, param);
      dispatch({
        type: FETCH_USERLOGINLIST_LOADING,
      });
      const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/login/list`, {
        method: 'GET',
        body: req,
      });
      fetchData.then((res) => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_USERLOGINLIST_SUCCESS,
            loginList: res.data.content || [],
            loginPageTotal: res.data.totalSize || 0,
          });
        } else {
          dispatch({
            type: FETCH_USERLOGINLIST_SUCCESS,
            loginList: [],
            loginPageTotal: 0,
          });
        }
      }).catch(e => {
        message.error(intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_USERLOGINLIST_FAILED,
        });
      })
    }
  };
}
/**
 * 用户的设备列表信息
 * @param {object} param 
 * @returns 
 */
export function fetchUserDeviceList(param) {
  return (dispatch, getState) => {
    const { userId } = getState().queryUser.userInfo;
    if (!!userId) {
      const defaultParam = { userId }
      const req = Object.assign({}, defaultParam, param);
      dispatch({
        type: FETCH_DEVICELIST_LOADING,
      });
      const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/devices`, {
        method: 'GET',
        body: req,
      });
      fetchData.then((res) => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_DEVICELIST_SUCCESS,
            deviceList: res.data.content || [],
            devicePageTotal: res.data.totalSize || 0,
          });
        } else {
          dispatch({
            type: FETCH_DEVICELIST_SUCCESS,
            deviceList: [],
            devicePageTotal: 0,
          });
        }
      }).catch(e => {
        message.error(intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_DEVICELIST_FAILED,
        });
      })
    }
  };
}






/**
 * 用户的家庭列表信息
 * @param {object} param 
 * @returns 
 */
export function fetchUserFamilyList(param) {
  return (dispatch, getState) => {
    const { userId } = getState().queryUser.userInfo;
    if (!!userId) {
      const defaultParam = { userId, }
      const req = Object.assign({}, defaultParam, param);
      const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/familyDetail`, {
        method: 'GET',
        body: req,
      });
      fetchData.then((res) => {
        if (res.code == 200) {
          dispatch({
            type: FETCH_FAMILYLIST_SUCCESS,
            familyList: res.data.content || [],
            familyPageTotal: res.data.totalSize || 0,
          });
        } else {
          dispatch({
            type: FETCH_FAMILYLIST_SUCCESS,
            familyList: [],
            familyPageTotal: 0,
          });
        }
      }).catch(e => {
        message.error(intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_FAMILYLIST_SUCCESS,
          familyList: [],
          familyPageTotal: 0,
        });
      })
    }
  };
}

/**
 * 注销用户
 * @param {object} param 
 * @returns 
 */
export function fetchwriteOffUser(param, callback) {
  return (dispatch, getState) => {
    const { userId } = getState().queryUser.userInfo;
    const defaultParam = { userId, }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/delay/del`, {
      method: 'POST',
      query: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        message.success(intl.get('commmon.operate.success'));
        callback && callback()
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 查询注销记录
 * @param {object} param 
 * @returns 
 */
export function fetchwriteOffList(param) {
  return (dispatch, getState) => {
    const req = Object.assign({}, param);
    dispatch({
      type: FETCH_WRITEOFFf_LOADING,
      status: true,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/service/user/del/info`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        // syhqa@mailto.plus3
        dispatch({
          type: FETCH_WRITEOFFf_SUCCESS,
          data: res.data.content || [],
          total: res.data.totalSize || 0,
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_WRITEOFFf_SUCCESS,
          data: [],
          total: 0,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_WRITEOFFf_SUCCESS,
        data: [],
        total: 0,
      });
      dispatch({
        type: FETCH_WRITEOFFf_LOADING,
        status: false,
      });
    })
  };
}



/**
 * 数据导出
 * @returns 
 */
export function fetchExportData(language) {
  return (dispatch, getState) => {
    const { userId } = getState().queryUser.userInfo;
    debugger
    if (!userId) {
      message.error(intl.get('home.user.writeOff.failTips'));
    } else {
      fetch(`${util.requestPath}/api/iot/support/service/user/export?userId=${userId}`, {
        method: 'GET',
        headers: { lang: language || 'zh-CN' }
      }).then((res) => {
        const ddd = decodeURIComponent(res.headers.get("Content-Disposition").split(`utf-8''`)[1]);
        res.blob().then((blob) => {
          const blobUrls = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrls;
          a.download = ddd;
          a.click();
          window.URL.revokeObjectURL(blobUrls);
        });
      }).catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      })
    }
  };
}
